import React, { Fragment, useContext } from 'react';
import useLanguageLinks from '../navigation/useLanguageLinks';
import LangA from '../../i18n/LangA';
import CloudflareImage from '../cloudflare-image/CloudflareImage';
import { getCookie } from '../../utils/cookies';
import { CookieState } from '../layout/layout';

const FooterLanguage = () => {
  const languageLinks = useLanguageLinks();
  const cookies = useContext(CookieState);

  const toggleCookieModal = () => {
    const hasGivenConsent = getCookie('cookieConsent');

    if (hasGivenConsent) {
      cookies.toggleCookieSettings(true);
      cookies.toggleCookieModal();
      // cookies.toggleHideBackButton?.();
    }
  };

  const showAccept = getCookie('zb_non_euca');

  return (
    <Fragment>
      <div className="footer_language">
        {languageLinks.map((ll) => {
          if (ll.isCurrent) {
            return (
              <div className="ie11-link-lg" key={ll.lang}>
                <CloudflareImage
                  id={'footer_' + ll.lang + '_button'}
                  src={ll.flag_bold}
                  alt={ll.languageName}
                  className="country-flag"
                  loading="lazy"
                  decoding="async"
                  width="37"
                  height="32"
                />
              </div>
            );
          } else {
            return (
              <div className="ie11-link-lg" key={ll.lang}>
                <LangA href={ll.path} title={ll.languageName}>
                  <CloudflareImage
                    id={'footer_' + ll.lang + '_button'}
                    src={ll.flag}
                    alt={ll.languageName}
                    className="country-flag"
                    loading="lazy"
                    decoding="async"
                    width="32"
                    height="27"
                  />
                </LangA>
              </div>
            );
          }
        })}
      </div>
      {showAccept && (
        <div className={'manage-cookie-preferences'} onClick={() => toggleCookieModal()}>
          Manage Cookie Preferences
        </div>
      )}
    </Fragment>
  );
};

export default FooterLanguage;
